import api_config from '../config/api'

export default {
	getCareers(lang) {
		return api_config.get(`api/career/${lang}`)
	},
}
